module.exports = __webpack_public_path__ + "static/media/icon-apple-store-wht-circle.10995cb5.svg";